var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortPositionLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.54542 13.841C1.95608 13.2587 1.95031 12.309 2.53252 11.7197C3.11473 11.1303 4.06446 11.1246 4.6538 11.7068L2.54542 13.841ZM20.512 15.3085L19.4553 14.2438L20.512 15.3085ZM21.9235 15.3111L22.9842 14.2505L21.9235 15.3111ZM4.6538 11.7068L13.7049 20.6484L11.5965 22.7826L2.54542 13.841L4.6538 11.7068ZM13.0012 20.6492L19.4553 14.2438L21.5686 16.3731L15.1145 22.7785L13.0012 20.6492ZM22.9842 14.2505L31.4443 22.7106L29.323 24.8319L20.8629 16.3718L22.9842 14.2505ZM19.4553 14.2438C20.4327 13.2738 22.0105 13.2768 22.9842 14.2505L20.8629 16.3718C21.0576 16.5665 21.3731 16.5671 21.5686 16.3731L19.4553 14.2438ZM13.7049 20.6484C13.5098 20.4557 13.1959 20.456 13.0012 20.6492L15.1145 22.7785C14.1413 23.7444 12.5719 23.7462 11.5965 22.7826L13.7049 20.6484Z",
    fill: "#F6475D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4219 24.7112H30.8297C31.3819 24.7112 31.8297 24.2635 31.8297 23.7112V15.3049",
    stroke: "#F6475D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortPositionLight);
export default __webpack_public_path__ + "static/media/shortPositionLight.2179765e6586db98073c129027e82502.svg";
export { ForwardRef as ReactComponent };